<template>
  <div class="text-center">
    <div class="heading-3">
      <span class="primary--text"
        >${{ swuTotalAUM | numberFormat("0,0") }}</span
      >
      <span class="ml-1"
        >earning yield <br />
        across multichain ecosystems</span
      >
    </div>
    <div class="mt-8">
      <c-btn :to="{ name: 'Yield' }">Start Earning</c-btn>
    </div>
    <div class="mt-4 gray--text text-4">
      Need crypto? Buy some to get started →
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters({
    swuTotalAUM: "productStats/swuTotalAUM",
  }),
};
</script>
